export default "__VITE_PUBLIC_ASSET__170499e0__"